import { Component, effect, inject, input, model } from '@angular/core';
import { injectAccordionState, NgpAccordion } from 'ng-primitives/accordion';

@Component({
  selector: 'joii-accordion',
  hostDirectives: [
    {
      directive: NgpAccordion,
      inputs: [
        'ngpAccordionType:type',
        'ngpAccordionCollapsible:collapsible',
        'ngpAccordionDisabled:disabled',
        'ngpAccordionOrientation:orientation',
      ],
    },
  ],
  template: ` <ng-content /> `,
  styles: `
    :host {
      display: block;
      width: 100%;
      border-radius: var(--Vetai-Radius-2);
      border: 1px solid var(--Vetai-Form_controls--Border_Default);
      background-color: var(--Vetai-Backgrounds--Base);
      overflow: hidden;
    }
    :host([data-borderless='true']) {
      border: none;
    }
  `,
  host: {
    '[attr.data-borderless]': 'borderless()',
  },
})
export class AccordionComponent {
  readonly borderless = input<boolean>(false);
  readonly activeValue = model<string | string[] | null>(null);

  private readonly accordion = injectAccordionState<string>();
  private readonly accordionDirective = inject(NgpAccordion);

  constructor() {
    effect(() => {
      const current = this.activeValue();
      if (this.accordion().value() !== current) {
        this.accordion().setValue(current);
      }
    });

    this.accordionDirective.valueChange.subscribe((next) => {
      const value = next as string | string[] | null;
      if (this.activeValue() !== value) {
        this.activeValue.set(value);
      }
    });
  }
}
